import React from "react";

import TotalPerfumePresenter from "./TotalPerfumePresenter";

export default class extends React.Component {

  render() {
    return <TotalPerfumePresenter />;
  }
}
